export default __webpack_public_path__ + "images/67bcf991b8acdbe3d6253ba2c03363ea-track_and_field_small.webp";